import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory, useParams } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, fetchData1 } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function UserDescription() {

    const { id } = useParams();

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isIdValid, setIsIdValid] = useState(true);

    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [from, setFromDate] = useState("");
    const [to, setToDate] = useState("");
    const history = useHistory(); // Access the navigation history
    const [rolelist, setRoleOptions] = useState([]);
    const { isAuthenticated, clubId, branchId, permissions, token, logout } = useAuth();


    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');


    const [selectedRoles, setSelectedRoles] = useState({});

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user

            logout();
            return;
        }

        // Token is not expired, fetch data


    }, [isAuthenticated, clubId, branchId, token, logout]);



    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        dateOfJoining: '',
        weddingAnniversary: '',
        email: '',
        phoneNumber: '',
        remark: '',
        gender: '',
        bloodGroupId: null,
        dateofleavingfrom: '',
        dateofleavingTo: '',
        expirydate: '',
        status: '',
    });




    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        if (id) {
            fetchData('MemberApi', `/GetMemberDetails/${id}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {
                        const memberDatas = response.response_data.memberdata;
                        setFormData({
                            ...memberDatas,

                        });

                    } else {
                        setIsIdValid(false);
                        setErrorMessage('Invalid ID. No record found.');
                    }
                })
                .catch((error) => {
                    console.error('Error fetching Member Details:', error);
                    setIsIdValid(false);
                    setErrorMessage('Failed to fetch member details.');
                });
        } else {
            setIsIdValid(false);
            setErrorMessage('Invalid ID. Please try again.');
        }
    }, [id, isAuthenticated, token, logout]);

    useEffect(() => {

        fetchtableData();

    }, []);

    const fetchtableData = async () => {
        fetchData('RoleApi', `/${clubId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const options = response.response_data.map(role => ({
                        value: role.Id,
                        label: role.Name,
                    }));
                    setRoleOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching Role Details:', error);
            });
    };



    const handleSubmit = async (e) => {
        //     e.preventDefault();

        //     if (!isSubmit) {
        //         return;
        //     }

        //        const CreateData = {
        //         FirstName: firstname || null,  // Pass null if lastname is falsy
        //         LastName: lastname || null,  // Pass null if firstname is falsy
        //         WeddingAnniversary: weddinganniversary || null,  // Null if weddinganniversary is falsy

        //     };


        //     try {
        //         const response = await postData('MemberApi', memberandfamilydata, token);
        //         console.log('m Created success:', response);
        //         setSuccessMessage("M Created successfully!");
        //         setErrorMessage("");
        //         clearForm();
        //         setTimeout(() => {
        //             setSuccessMessage("");


        //         }, 3000);
        //         window.location.reload();
        //     } catch (error) {
        //         console.error('M Create error:', error);
        //     }
    };

    const handleRoleSelectChange = (selectedOption) => {
        setSelectedRoles(selectedOption.value);
    };




    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className="w-full mb-2 flex">
                <h6 className="productHead flex-grow linkcolor" style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                   Role Settings
                </h6>
                <div className="button-container-2" style={{ marginRight: '10px' }}>
                    <Button
                        onClick={handleSubmit}
                        style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#EDC001' }}
                        disabled={!isIdValid}
                    >
                        UPDATE
                    </Button>
                </div>
                <div className="button-container-3">
                    <Button
                        type="button"
                        onClick={() => history.push('/MemberIndex')}
                        className="linkcolor"
                        style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#EDC001' }}
                    >
                        CANCEL
                    </Button>
                </div>
            </div>


            {/* Added mb-4 for spacing */}
            <div className="w-full grid grid-cols-5 gap-4 mb-2">
                <div>
                    <label htmlFor="name">First Name</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        name="firstName"
                        value={formData.firstName}
                        type="text"
                        placeholder="Enter Name"
                        disabled={!isIdValid}
                    />
                </div>

                <div>
                    <label htmlFor="Last Name">Last Name</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                        name="lastName"
                        value={formData.lastName}
                        type="text"
                        placeholder="Enter Last Name"
                        disabled={!isIdValid}
                    />
                </div>


                <div>
                    <label htmlFor="code">Email</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                        name="email"
                        value={formData.email}
                        type="text"
                        placeholder="Enter Email"
                        disabled={!isIdValid}
                    />
                </div>

            </div>
            <div className="w-full grid grid-cols-5 gap-4">
                <div>
                    <Select
                        value={rolelist.find(role => role.value === selectedRoles)} // Show selected value
                        onChange={handleRoleSelectChange} // Handle selection
                        options={rolelist} // Provide options (memberlist already has the right format)

                        placeholder="Select Role"
                        isSearchable // Makes the dropdown searchable
                    />
                </div>
            </div>





        </div>
    );
}

export default UserDescription;




